export const LEGACY_TOWN_AVATAR_SKIN_HEX = {
  porcelain: "#f1c7aa", peach: "#dfa37d", golden: "#c88959", tan: "#ad704d", brown: "#7c4c35", deep: "#513326",
} as const;
export const LEGACY_TOWN_AVATAR_HAIR_HEX = {
  black: "#171820", espresso: "#30252d", chestnut: "#623d30", copper: "#b85e43", blonde: "#c99d58", silver: "#a9a7b0", rose: "#a45d74", blue: "#405f80",
} as const;
export const LEGACY_TOWN_AVATAR_CLOTHING_HEX = {
  coral: "#e76f61", amber: "#d9a13b", sage: "#6d998a", sky: "#668eaf", plum: "#8b658d", navy: "#40536f", cream: "#e8d9ba", charcoal: "#4a4a55",
} as const;
export type LegacySkinTone = keyof typeof LEGACY_TOWN_AVATAR_SKIN_HEX;
export type LegacyHairColor = keyof typeof LEGACY_TOWN_AVATAR_HAIR_HEX;
export type LegacyClothingColor = keyof typeof LEGACY_TOWN_AVATAR_CLOTHING_HEX;
